/**
 * @generated SignedSource<<ad0662277c7329577865a233968a7305>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationAdminWebFetcherListItem_IntegrationWebFetcher$data = {
  readonly __typename: "IntegrationWebFetch";
  readonly id: string;
  readonly lastError: string | null;
  readonly url: string;
  readonly " $fragmentType": "IntegrationAdminWebFetcherListItem_IntegrationWebFetcher";
};
export type IntegrationAdminWebFetcherListItem_IntegrationWebFetcher$key = {
  readonly " $data"?: IntegrationAdminWebFetcherListItem_IntegrationWebFetcher$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationAdminWebFetcherListItem_IntegrationWebFetcher">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationAdminWebFetcherListItem_IntegrationWebFetcher",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastError",
      "storageKey": null
    }
  ],
  "type": "IntegrationWebFetch",
  "abstractKey": null
};

(node as any).hash = "6e35798951da6787ef1b57ad36adc29e";

export default node;
